import Config from "../config/config.json";


export default class DecryptionService {
    private readonly PUBLIC_PEM_TEST: string;
    private readonly PUBLIC_PEM: string;

    constructor(pem: string | null) {
        // const v = process.env.REACT_APP_PUBLIC_KEY_VERSION;
        this.PUBLIC_PEM = process.env.REACT_APP_PUBLIC_KEY || Config.REACT_APP_PUBLIC_KEY;
        this.PUBLIC_PEM_TEST = pem || process.env.REACT_APP_PUBLIC_KEY_TEST || Config.REACT_APP_PUBLIC_KEY;

    }

    private getKey(isTest: boolean): string {
        let key = this.PUBLIC_PEM;
        if (isTest) key = this.PUBLIC_PEM_TEST;
        console.log("key: ", key);
        return "-----BEGIN PUBLIC KEY-----\n" + key + "\n-----END PUBLIC KEY-----"
    }

    public async verifySignature(cypher: string, data: string, isTest: boolean = false): Promise<boolean> {
        let enc = new TextEncoder();
        const encoded = enc.encode(data);
        const signature = Uint8Array.from(atob(cypher), (c) => c.charCodeAt(0));

        const publicKey = await this.importPublicRsaKey(this.getKey(isTest));
        const result = crypto.subtle.verify("RSASSA-PKCS1-v1_5", publicKey, signature, encoded);
        return result;
    }

    // converts string based RSA key to window.crypto compatible key
    private async importPublicRsaKey(pem: string) {
        // fetch the part of the PEM string between header and footer
        const pemHeader = "-----BEGIN PUBLIC KEY-----";
        const pemFooter = "-----END PUBLIC KEY-----";
        const pemContents = pem.substring(pemHeader.length, pem.length - pemFooter.length);
        // base64 decode the string to get the binary data
        const binaryDerString = window.atob(pemContents);
        const binaryDer = this.binStr2ab(binaryDerString);

        return window.crypto.subtle.importKey(
            "spki",
            binaryDer,
            {
                name: "RSASSA-PKCS1-v1_5",
                hash: "SHA-512"
            },
            true,
            ["verify"]
        );
    }

    // convert from a binary string to an ArrayBuffer
    private binStr2ab(str: string) {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }

    // convert from an ArrayBuffer to a binary string
    public ab2str(buf: ArrayBuffer) {
        // @ts-ignore
        return String.fromCharCode.apply(null, new Uint8Array(buf));
    }
}
